import { createTheme } from '@material-ui/core'

const theme = createTheme({
  palette: {
    yuzuPrimary: {
      main: '#fecd00',
    },
    primary: {
      light: '#fff1bb',
      main: '#fecd00',
      dark: '#e6ba02',
      contrastText: '#40474f',
    },
    secondary: {
      light: '#aaeb3b',
      main: '#9ad535',
      dark: '#8cd117',
      contrastText: '#ffffff',
    },
    error: {
      light: '#ff7468',
      main: '#d2423d',
      dark: '#9a0016',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: ['"Helvetica"', 'Arial', 'sans-serif'].join(','),
  },
  fontSize: 12,
  htmlFontSize: 10,
  overrides: {
    MuiInputBase: {
      root: {
        color: '#4a4a4a',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
        borderRadius: 3,
        boxShadow: 'none',
        fontSize: 14,
        fontWeight: 'bold',
        padding: '0 10px',
      },
      text: {
        width: 'inherit',
        color: 'grey',
        fontWeight: 'bolder',
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
      },
      label: {
        width: 'inherit',
      },
    },
  },
})

export default theme
